import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import IndexSix from "./index/index-six";
import Auth from "./components/auth";
import Dashboard from "./components/dashboard";
import AlbumDashboard from "./components/AlbumDashboard";
import Pricing from "./components/pricing";
import ProtectedRoute from "./ProtectedRoute";
import { setUser } from "./redux/slices/authSlice";
import Token from "./components/token";
import CreateAlbum from "./components/CreateAlbum";
import UploadImages from "./components/UploadImages";
import ShareAlbum from "./components/ShareAlbum";
import Terms from "./components/Terms";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ReturnPolicy from "./components/ReturnPolicy";

const App: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        dispatch(setUser(parsedUser));
      } catch (error) {
        console.error("Failed to parse user from localStorage", error);
      }
    }
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/" element={<IndexSix />} />
      <Route
        path="/auth"
        element={
          <ProtectedRoute authRequired={false}>
            <Auth />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/:albumId/:albumName/:createdBy"
        element={
          <ProtectedRoute authRequired={true}>
            <AlbumDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute authRequired={true}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pricing"
        element={
          <ProtectedRoute authRequired={true}>
            <Pricing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tokens"
        element={
          <ProtectedRoute authRequired={true}>
            <Token />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-album"
        element={
          <ProtectedRoute authRequired={true}>
            <CreateAlbum />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload-images"
        element={
          <ProtectedRoute authRequired={true}>
            <UploadImages />
          </ProtectedRoute>
        }
      />
      <Route
        path="/share-album/:albumId/:userId"
        element={
          <ProtectedRoute authRequired={true}>
            <ShareAlbum />
          </ProtectedRoute>
        }
      />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
      {/* <Route path="/return-policy" element={<ReturnPolicy/>} /> */}
      <Route path="*" element={<IndexSix />} />
    </Routes>
  );
};

export default App;
